import { motion } from "framer-motion";

/**
 * Customer logo wall for the OpsIQ homepage.
 * Placeholder cards for now — swap the `name` and (optional) `logo` fields as real clients come in.
 */
const CLIENTS = [
  { name: "GIDA Hospitality" },
  { name: "WashFlow Clients" },
  { name: "Retail Group" },
  { name: "Manufacturing Co." },
  { name: "Financial Services" },
  { name: "Public Sector" },
];

export default function OpsCustomers() {
  return (
    <section
      id="customers"
      className="relative bg-[#F1ECE0] text-[#1A2E4A] border-t border-[#1A2E4A]/10"
      data-testid="customers-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-10 md:mb-14">
          <div className="lg:col-span-7">
            <div className="text-[11px] font-plex-mono uppercase tracking-[0.26em] text-[#1A2E4A] mb-5 inline-flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#B8E024]" />
              Customers
            </div>
            <h2 className="font-editorial text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Trusted by Ghanaian businesses <span className="italic">that mean business.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-[#1A2E4A]/70 max-w-md">
            A sample of the organisations OpsIQ supports with Command Centres, Operational Intelligence and our products
            GIDA and WashFlow.
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-t border-l border-[#1A2E4A]/15">
          {CLIENTS.map((c, i) => (
            <motion.div
              key={c.name + i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="aspect-[5/3] md:aspect-[4/3] border-b border-r border-[#1A2E4A]/15 flex items-center justify-center p-6 md:p-8 group hover:bg-[#1A2E4A] hover:text-[#F1ECE0] transition-colors"
            >
              <span className="font-plex-mono text-[10px] md:text-xs uppercase tracking-[0.22em] text-[#1A2E4A]/55 group-hover:text-[#D9FF3C] text-center">
                {c.name}
              </span>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 text-xs font-plex-mono uppercase tracking-[0.22em] text-[#1A2E4A]/45">
          Full client list and named case studies available on request.
        </p>
      </div>
    </section>
  );
}
